# GraphQL fragment to enable/disable Office365 calendar sync

#import "../fragments/calendar-sync.graphql"

mutation setOffice365CalendarSyncIsEnabled($isEnabled: Boolean!) {
    setOffice365CalendarSyncIsEnabled(input: {calendarSync: {isEnabled: $isEnabled}}) {
        authUrl
        calendarSync {
            ...CalendarSync
        }
    }
}
